import SimpleDialog from 'app/componentV4/Dialog/SimpleDialog'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import React, { useEffect, useState } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import OutlinedButtons from 'app/componentV4/Button/OutlinedButtons'
import { CLOSE, SECONDARY } from 'app/constants/button'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import { useGroupDialog } from '../contexts/GroupDialogContext'
import useSubscribers from 'app/main/subscribersV4/useSubscribers'
import { DIALOG_KEYS } from '../constants'
import Assets from 'app/configs/assetConfigs'
import DataTable from 'app/componentV4/Table/DataTable'
import { ColumnOfSubscriberWitoutGroup } from '../ColumnOfSubscriberData'
import {
  InputAdornment,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import clsx from 'clsx'
import SearchIcon from '@material-ui/icons/Search'
import { isEmptyOrNil } from 'libs/empty'
import { mergeLeft } from 'ramda'
import MessagespringLoading from 'app/componentV4/Loader/MessagespringLoading'
import { CRM_LIMIT } from 'app/constants/subscriberCRM'

const useStyle = makeStyles((theme) => ({
  table: {
    '&.data-table': {
      [theme.breakpoints.up('md')]: {
        height: 'calc(100vh - 150px)',
      },
    },
  },
  dialog: {
    '& .MuiDialog-container': {
      width: '100%',
      maxWidth: 'none',
    },
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 'none',
      width: '80%',
      overflow: 'hidden',
    },
  },
  dialogMobile: {
    '& .MuiDialog-container': {
      width: '100%',
      maxWidth: 'none',
    },
    '& .MuiDialog-paperWidthSm': {
      width: '100%',
      maxWidth: 'none',
      padding: '0 !important',
      margin: '0',
      height: '100%',
      maxHeight: 'none',
      overflow: 'hidden',
    },
  },
}))

const AddSubscriberToSubGroup = () => {
  const { formatMessage } = useIntl()
  const classes = useStyle()
  const theme = useTheme()
  const isDownXs = useMediaQuery(theme.breakpoints.down('sm'))
  const [searchText, onSearchText] = useState('')
  const [isResetSelected, setIsResetSelected] = useState(false)
  const { dialogState, closeDialog } = useGroupDialog()
  const { open, action, isLoading } = dialogState[DIALOG_KEYS.ADD_SUBSCRIBER]

  const [selectedIds, setSelectedIds] = useState([])

  const handleSubmit = () => {
    action?.onSubmit?.({ subscriberIds: selectedIds })
  }

  const handleSelected = (value, values = []) => {
    const subscriberIds = Object.values(value).flat()
    setSelectedIds(subscriberIds.concat(values))
  }

  const onClearData = () => {
    setSelectedIds({})
    setIsResetSelected(true)
  }

  const {
    state: {
      params,
      isEmptySubscribers,
      isLoadingSubscribers,
      subscribers,
      isFirstLoad,
    },
    fetchSubscriberNotInTags,
    handleSearchSubscriberForTags,
    onClearState,
  } = useSubscribers()
  const { data, meta } = subscribers

  useEffect(() => {
    if (open) {
      fetchSubscriberNotInTags({ ...params, tagId: action?.tagId })
    }
    return () => {
      onClearState()
      onSearchText('')
    }
  }, [open])

  useEffect(() => {
    if (isResetSelected) setIsResetSelected(false)
  }, [isResetSelected])

  return (
    <SimpleDialog
      id="dialog-add-group"
      open={open}
      className={clsx(
        isDownXs ? classes.dialogMobile : classes.dialog,
        'p-5 overflow-hidden',
      )}
      title={
        <div className="text-blue-950 py-5 px-10 text-16 font-medium w-full">
          <FormattedMessage
            id="groupsv4.dialog.add.subscriber.member.title"
            values={{
              name: `${action?.name}`,
            }}
          />
        </div>
      }
      isLoading={isLoading}
      onClose={() => closeDialog(DIALOG_KEYS.ADD_SUBSCRIBER)}
    >
      {isFirstLoad && isLoadingSubscribers ? (
        <div className="w-full h-[75vh] flex items-center justify-center">
          <MessagespringLoading />
        </div>
      ) : (
        <div className="px-10">
          {isEmptySubscribers ? (
            <div className="w-full h-[75vh] text-blue-950 flex justify-center items-center">
              <div className="justify-center text-center">
                <div className="w-full flex justify-center">
                  <img
                    src={Assets.groupv4EmptySubscriberIcon}
                    alt="Empty subscriber on group"
                  />
                </div>
                <div className="text-lg font-bold text-center text-primary">
                  <FormattedMessage id="groupv4.addMember.empty.title" />
                </div>
                <div className="my-5 w-512">
                  <div className="text-md text-primary text-center">
                    <FormattedMessage id="groupv4.addMember.empty.description" />
                  </div>
                </div>
                <div className="mt-10">
                  <OutlinedButtons
                    id="close-add-dialog-when-empty-subscriber"
                    color={CLOSE}
                    onClick={() => closeDialog(DIALOG_KEYS.ADD_SUBSCRIBER)}
                    className="uppercase"
                  >
                    {formatMessage({ id: 'text.close' })}
                  </OutlinedButtons>
                </div>
              </div>
            </div>
          ) : (
            <div className="w-full h-full text-blue-950">
              <div
                className={clsx(
                  'flex flex-col h-full',
                  isDownXs && 'overflow-y-auto',
                )}
              >
                <div className="p-4 grow space-y-5">
                  <SimpleInput
                    id="search-subscriber-not-group"
                    name="search"
                    placeholder={formatMessage({
                      id: 'input.searchSubscriber',
                    })}
                    value={searchText}
                    fullWidth
                    size="small"
                    onChange={(event) => {
                      onSearchText(event.target.value)
                      handleSearchSubscriberForTags(
                        event.target.value,
                        onClearData,
                      )
                    }}
                    startAdornment={
                      <InputAdornment position="start">
                        <SearchIcon className="text-grey-400" />
                      </InputAdornment>
                    }
                  />
                  <DataTable
                    data={data}
                    isCheckbox={true}
                    isResetAllSelected={isResetSelected}
                    className={clsx(isDownXs ? 'h-[75vh]' : 'h-[65vh]')}
                    columns={ColumnOfSubscriberWitoutGroup(
                      isDownXs,
                      formatMessage,
                    )}
                    pagination={meta}
                    sticky={isDownXs ? 'checkBox' : 'firstName'}
                    isLoading={isLoadingSubscribers || isLoading}
                    customSelectedCount={selectedIds.length}
                    onChange={(value, values) => {
                      handleSelected(value, values)
                    }}
                    onFetch={(values) =>
                      fetchSubscriberNotInTags(
                        mergeLeft(
                          {
                            ...values,
                            tagId: action?.tagId,
                            keyword: searchText,
                          },
                          params,
                        ),
                      )
                    }
                    selectionLimit={CRM_LIMIT}
                  />
                </div>

                <div className="p-2 shrink-0">
                  <div className="w-full p-5 text-center space-x-5">
                    <OutlinedButtons
                      id="close-add-subscriber-btn"
                      type="button"
                      color={CLOSE}
                      disabled={isLoading}
                      onClick={() => {
                        setSelectedIds({})
                        onSearchText('')
                        closeDialog(DIALOG_KEYS.ADD_SUBSCRIBER)
                      }}
                    >
                      <FormattedMessage id="action.cancel" />
                    </OutlinedButtons>
                    <ContainedButton
                      id="add-subscriber-btn"
                      color={SECONDARY}
                      isLoading={isLoading}
                      type="button"
                      onClick={handleSubmit}
                      disabled={
                        isLoading ||
                        isEmptyOrNil(Object.values(selectedIds).flat())
                      }
                    >
                      <FormattedMessage id="subscriber.dialog.createSubscriber" />
                    </ContainedButton>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </SimpleDialog>
  )
}

export default AddSubscriberToSubGroup
